import login from './login';
import route from './route';
import common from './common';
import layout from './layout';
import stuManagement from './student_management';
import validate from './validate';
import message from './message';
import insInfo from './institution_info';
import insInfoSearch from './institution_info_search';
import mps from './mps';
import company from './company';
import tagsView from './tagsView';
import popupNotice from './popup_notice';

export default {
  index: {
    countryDistributionPieTitle: 'Application - Distribution by country',
    nowStudentCount: 'Number of students in {year}',
    nowReadingCount: 'Number of {text} in {year}',
    allStudentCount: 'Total students',
    allReadingCount: 'Total {text}',
    enrolledSuccessProportion: 'Success Rate',
    studentTotalSum: 'Student Numbers (Application Counts)',
    enrolledSuccess: 'Enrollment',
    enrollment: 'Enrollment',
    applicationCountBarTitle: 'Number of Student/{text}',
    applyCount: 'Application',
    goProScore: 'GoPro Score',
    successfulEnrolment: 'Enrollment',
    studentCount: 'Student',
    enrolment: 'Enrollment',
    applyStatus: 'Status',
    successfulContract: 'Enrolled',
    studentOverview: "Overview",
    studentQuery: "Student",
    studentQueryList: 'Student List',
    applicationList: "Application",
    addStudent: 'New applicant',
    pending: "Pending",
    stepNewAppCount: "New application",
    submitted: "Submitted",
    stepFailureCount: 'No Offer',
    admittedOffer: "Admitted",
    paid: "Paid",
    enrolled: "Enrolled",
    stateUpdate: "update the state",
    studentOffer: 'Student Application',
    consultant: 'Consultant',
    studentPage: 'Student Page',
    returnStudentPage: 'Return to Student Page',
    newApplication: 'New Application',
    gmtCreate: 'Created',
    gmtModified: 'Updated',
    application: 'Application',
    stepDepositPaidCount: 'Pay Deposit',
    stepOfferSelectionCount: 'Visa Letter',
    stepVisaGrantedCount: 'Visa',
    stepEnrolledCount: 'Enrolled',
    stepPayPremiumCount: 'Pay Commission',
    nationality: 'Nationality/Region',
    nationalityPassport: 'Passport Nationality/Region',
    passport: 'passport',
    passportFrom: 'Passport from?',
    birthday: 'Birthday',
    startDate: 'Start Date',
    endDate: 'End Date',
    level: 'Level',
    course: 'Course',
    accommodation: 'Accommodation',
    airportPickup: 'Airport Pickup',
    need: 'Need',
    noNeed: 'No Need ',
    schoolType: 'School Type',
    school: 'School',
    courseApply: 'Course Application',
    applyDetail: 'Application Detail',
    applyContentForm: 'Application Form',
    personalProfile: 'Personal Profile',
    educationalBackground: 'Educational Background',
    educationBackground: 'Education Background',
    personalBackground: 'Personal Background',
    referrer: 'Referrer {num}',
    workExperience: 'Work Experience',
    professionalQualification: 'Professional Qualification',
    applyAttachment: 'Attachment',
    addAttachment: 'Add Attachment',
    packWord: 'Pack into WORD',
    packDownloadAllFile: 'Package and download all files',
    applicant: 'Applicant',
    applicantData: 'Applicant Information',
    applyId: 'Apply ID.',
    studyCountry: 'Study Country',
    studyCountryRegion: 'Country/Region',
    institutionName: 'Institution',
    institution: 'Institution',
    attachment: 'Attachment',
    applyNo: 'App ID.',
    statusUpdateDate: 'Updated',
    processingDays: 'Processing Days',
    applyStatusAttachment: 'Attachment',
    stepNotes: 'Remarks',
    examType: 'Examination Type',
    want: 'Want',
    notWant: 'Do not Want ',
    ieltsType: 'IELTS Type',
    examTotal: 'Total',
    examListen: 'Listen',
    examRead: 'Read',
    examWrite: 'Write',
    examSpeak: 'Speak',
    testCenterNumber: 'Test Center Number',
    examinationDate: 'Examination Date',
    examinationNumber: 'Examination Number',
    examinationCheckAccount: 'Examination Check Account',
    isReexamination: 'Retake?',
    englishExamRecord: 'English Exam Record',
    allAttachment: 'All Attachments',
    uploadDate: 'Upload Date',
    fileName: 'File Name',
    attachmentTips: '(Cannot be re-uploaded/deleted after submission)',
    under18GuardianContact: 'Contact of Guardians of Applicant Aged Under 18',
    contact: 'Contact',
    fatherName: "Father's name",
    motherName: "Nother's name",
    mobileOrTel: 'Mobile/Telphone number',
    agentContact: 'Agent Contact',
    agentMobileOrTel1: 'Mobile/Telphone number 1',
    agentMobileOrTel2: 'Mobile/Telphone number 2',
    agentMobileOrTel3: 'Mobile/Telphone number 3',
    agentEmail1: 'Email 1',
    agentEmail2: 'Email 2',
    agentEmail3: 'Email 3',
    furtherInformation: 'Further Information',
    studyCountryLearning: 'Study in this Country/Region',
    religion: 'Religion',
    isVisaRefused: 'Countries or Regions that have been refused a visa',
    isDisability: 'Disabilities or Special needs',
    isEnglishMotherLanguage: 'Is English Mother Language',
    isStudyInEnglish: 'High school or above where English is the language of instruction',
    enrolledSchool: 'Enrolled Institution {index}',
    uploadFile: 'Upload File',
    typeOfInstitution: 'Type of Institution',
    address: 'Address',
    major: 'Major',
    studyStartDate: 'Study Start Date',
    studyEndDate: 'Study End Date',
    studyInEnglish: 'Teaching/Testing in English?',
    scoreOrTotal: 'Score/Total Score',
    isCompleted: 'Completed?',
    isShouldCompleted: 'Is Should Completed',
    studyAndExamInEnglish: 'English is the language of instruction and examination',
    studyInEnglishNotExam: 'English is the medium of instruction but examinations are not included',
    secondaryCourses: 'Secondary Courses',
    universityOrAboveCourses: 'University or above courses',
    qualificationName: 'Qualification Name',
    qualificationGroup: 'Certification Group',
    qualificationRegion: 'Certification Country/Region',
    qualificationGrade: 'Qualification Grade (if applicable)',
    qualificationStartDate: 'Qualification Start Date',
    qualificationGetDate: 'Qualification Get Date',
    qualificationGetStatus: 'Qualification Get Status',
    inProgress: 'In Progress',
    acquired: 'Acquired',
    workExperienceTips: 'Minimum number is most recent work ',
    companyName: 'Company Name',
    position: 'Position',
    workMode: 'Full-time/Part-time',
    fullTime:'Full-time',
    partTime: 'Part-time',
    workStartDate: 'Commencement Date',
    workEndDate: 'End-of-service Date',
    isOnDuty: 'Currently Employed or Not',
    jobDescription: 'Duty Description',
    companyAddress: 'Company Address',
    institutionOrCompany: 'Institution/Company',
    contactAddress: 'Contact Address-(Institution/individual)',
    postcode: 'Postcode',
    name: 'Name',
    openTimeStart: 'School Day Start',
    openTimeEnd: 'School Day End',
    statusBeginTime: 'Status Start Date',
    statusEndTime: 'Status End Date',
    statusTimeRange: 'Status Date',
    statusDays: 'Status Days',
    submitStartTime: 'Submit Start Date',
    submitEndTime: 'Submit End Date',
    createStartTime: 'Create Start Date',
    createEndTime: 'Create End Date',
    openingTime: 'Opening Date',
    updateTime: 'Updated',
    submitTime: 'Submitted',
    submitter: 'Submitter',
    days: 'Days',
    applicationCountry: 'Applicant Countries or Regions',
    total: 'Total',
    commission: 'Commission',
    dataCategory: 'Category',
    distribution: 'Distribution',
    yearCommission: "Annual Commission",
    receivedCommission: "Commission Received",
    unrealizedCommission: "Unrealized Commission",
    commissionRemark1: 'Commission - Projected commission based on the year of enrolment of the student',
    commissionRemark2: 'Enrollment - It is based on the year the student enrolled',
    commissionRemark3: 'Application - It is based on the creation date of the application',
    commissionRemark4: 'Student - It is based on the creation date of the student',
    overview: 'Overview',
    all: 'All',
    settleable: 'Settleable',
    unsettled: 'Open',
    settling: 'In Progress',
    received: 'Settled',
    applicationDistribution: 'Application - Distribution by month ',
    countryDistribution: 'Application - Distribution by country ',
    institutionsDistributionQSRanking: 'Distribution by institution QS ranking',
    top9: 'Top 9 schools',
    subjectDistribution: 'Distribution by subject ',
    offerItemCommission: 'Study abroad application',
    serviceFeeCommission: 'Study Abroad Service Fee',
    insuranceCommission: 'Insurance for Studying Abroad',
    accommodationCommission: 'Accommodation for Study Abroad',
    differentialSubmission: 'Submit for difference',
    submitSettlement: 'Confirm for settlement',
    totalCommission: 'Total Commission',
    currency: 'Currency',
    tuition: 'Tuition',
    commissionRatio: 'Commission Ratio',
    splitRate: 'Split Rate',
    paidAmount: 'Paid Amount',
    theReceivable: 'Receivable',
    auditOpinion: 'Audit Opinion',
    proposeDifference: 'Propose Difference',
    insuranceAmount: 'Insurance Amount',
    receivableAmount: 'Receivable Amount',
    apartmentName: 'Student Apartment',
    checkInTime: 'check In Time',
    arrivalDays: 'Arrival days',
    payableCommission: 'Commission Payable',
    currencyType: 'Currency',
    type: 'Type',
    checkStatement: 'Check the Statement',
    remarkMessage: 'Remark',
    eSignature: 'E-Signature',
    downloadStatement: 'Download Copy',
    previewStatement: 'Preview Statement',
    rolledBack: 'Statement has been rolled back, Click to view reason!',
    chineseAccoountTips: "If the bank account information provided is in Chinese, it will be settled in RMB by default.",
    englishAccoountTips: 'If the bank account information provided is in English, the default settlement is in foreign currency.',
    statementTips1: "Foreign currency settlement, the agent needs to provide an overseas foreign currency account (Hong Kong HSBC is preferred), RMB calculation, remittance needs to be paid through cross-border foreign exchange",
    statementTips2: "orders in the middle of the settlement month, the partner is advised to sign back within 3 days after receiving the commission order (the latest before the 20th of the current month) for confirmation",
    statementTips3: "After receiving the partner's signature confirmation, complete the remittance from the end of the month to the middle of the next month",
    statementTips4: "Due to the complicated process of cross-border remittance restrictions, the partner needs to reply whether the account has been received within 7 days. If the account has not been received after 7 days, it will not be accepted.",
    statementTips5: "Please ensure that the bank information (including the branch) is accurate. If the account error leads to the refund, the handling fee will be borne by your company",
    statementTips6: 'The remittance shall be settled in RMB with reference to the unified Hong Kong dollar and the Bank of China in Hong Kong at 10am on the day of the remittance ',
    statementTips7: "Institutions will incur intermediate bank handling charges ranging from 5-8% for each settlement, and GEA will deduct 5 yuan in local currency for each settlement (including advance payment).",
    unsettledSubmitTips1: 'We have started to review all your submitted bills, we will contact you as soon as possible, please check your email.',
    unsettledSubmitTips2_1: 'If you have any questions,',
    unsettledSubmitTips2_2: 'contact',
    unsettledSubmitTips2_3: 'the responsible',
    unsettledSubmitTips2_4: 'area manager.',
    unsettledSubmitTips3: 'You have a negative bill unconfirmed check!',
    submitAndESign: ' Submit and E-Sign',
    addSubmit: 'Add Submit',
    bankAccount: 'Bank Account',
    bankAccountSelect: 'Please select the bank account',
    settleMethod: 'Settle Approach',
    differentCurrency: 'Individual',
    unifiedCurrency: 'Unify',
    settleCurrency: 'Settlement currency',
    originCurrency: 'Original currency',
    transactionDate: 'Transaction date',
    limitFileSize: 'The size of the uploaded file cannot exceed 20M',
    uploadDragTips: 'Drag files here, or ',
    uploadDragTips2: 'click upload',
    uploadESigned: 'Upload E-Signed Files',
    uploadedStatement: 'Uploaded Statement',
    uploadStatementTips: 'Please upload statement',
    receivedTips: 'Show data for the last six months only',
    uploadSuccess: 'Upload Successfully',
    exportNoDataTips: 'The current search criteria have no data to export! ',
    studentUnit: ' student(s)',
    editStudentInfo: 'Edit Student Information',
    addApplyCourse:'Add course',
    noDataSettlingTips: 'There is no settlement data, please submit settlement first! ',
    hasSettlingCommissionTips: 'You have a commission settlement in progress. Please wait until the previous settlement is completed before submitting a new one. Previous submission time: {time}',
    differentialSubmissionQuestionTips: 'If you have any questions about the commission, you can click this button to send feedback and we will review it again for you.',
    noSearchResults: "No search results",
    totalProportion: "Total",
    submitSettlementTips: 'You have filled information but not yet confirmed. Do you sure you want to leave?',
    bmsMaskTips: 'Your commission settlement has been processed by BD in the BMS system. If you wish to switch to GEAR settlement instead, please contact your BD at: ',
    signedSucc: 'Enrolled',
    totleStudent: "Total number of students",
    welcomeBack: 'Welcome!',
    unsettledDesc: "Available to request settlement.",
    settlingDesc: "Confirm and Upload signed settlement request.",
    receivedDesc: "Settled claim.",
    settlementProcessStatus: "Settlement Process Status",
    studentEmailTips: "The student's email already exists. If multiple applications for the same student are submitted simultaneously, only one agent will receive the commission.",
    noSignature: 'Awaiting signature confirmation',
    eSignatureTips1: 'Please prepare the relevant',
    eSignatureTips1_1: ' E-signature',
    eSignatureTips1_2: ' and ',
    eSignatureTips1_3: 'Company chop',
    eSignatureTips1_4: ' in advance for upload.',
    companySealUpload: 'Company Chop File Upload',
    eSignatureUpload: 'E-Signature File Upload',
    uploadESignature: 'Upload E-Signature',
    uploadCompanySeal: 'Upload Company Chop',
    settlementConfirmation: 'Settlement Confirmation',
    eSignatureTips2: "You haven't signed and/or ",
    eSignatureTips2_1: "confirm the Settlement",
    eSignatureTips2_2: ". Are you sure you want to quit?",
    fileSizeTips: "(Recommendation: Keep the file size within 2MB.)",
    comparisonRecord: "Comparison Record",
    commissionSettledTips: 'The commission settlement period is scheduled from the {start}th to the {end}th of each month. Please settle your commissions within this timeframe.',
    ifApplicable: 'If Applicable',
    eSignatureTips3_1: "No e-signature available?",
    eSignatureTips3_2: " Tap to generate a hand-drawn signature.",
    handwrittenSignature: 'Hand-drawn Signature',
    clearSignature: 'Clear Signature',
    confirmandBackup: 'Confirm',
    eSignatureTips4_1: "Ensure your signature",
    eSignatureTips4_2: ' matches the font size in the example.',
    eSignatureTips4_3: 'Poorly written or tiny signatures may be rejected, causing delays in settlement.',
    eSignatureTips5_1: 'Ensure the signature image ',
    eSignatureTips5_2: 'has legible handwriting and a transparent background.',
    eSignatureTips5_3: ' If a corporate seal is used, verify that it is clearly visible.',
    eSignatureTips6_1: 'Preview and verify the statement with the composite e-signature. if there are no issues ',
    eSignatureTips6_2: "Click 'Settlement Confirmation'",
    eSignatureTips7: 'Please sign first!',
    pleaseEnterRemark: 'Please enter remark',
    currentStatisticsTips:'*Current statistics for the latest {year} data.',
  },
  login,
  route,
  common,
  message,
  ...layout,
  stuManagement,
  validate,
  insInfo,
  insInfoSearch,
  mps,
  company,
  tagsView,
  popupNotice,
};
